var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 25.0001L18.0706 18.0707M18.0706 18.0707C19.946 16.1953 20.9997 13.6517 20.9997 10.9994C20.9997 8.34713 19.946 5.8035 18.0706 3.92807C16.1952 2.05263 13.6515 0.999023 10.9993 0.999023C8.34701 0.999023 5.80338 2.05263 3.92794 3.92807C2.05251 5.8035 0.998901 8.34713 0.998901 10.9994C0.998901 13.6517 2.05251 16.1953 3.92794 18.0707C5.80338 19.9462 8.34701 20.9998 10.9993 20.9998C13.6515 20.9998 16.1952 19.9462 18.0706 18.0707Z",
    stroke: "#111111",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c9ce78e598d2d08dad0e15b6d92228b2.svg";
export { ForwardRef as ReactComponent };